var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tasks',{attrs:{"tabs":_vm.conditions,"tasks":_vm.tasks,"count":_vm.count,"pages":_vm.pages},on:{"refresh-request":_vm.refresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }